/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutPaymentInstrumentViewProps, ICheckoutPaymentOverlayModal } from './lds-checkout-payment-instrument-2';

import {
    getIdentificationTypesAsync,
    getIdentificationTypesApplicabilityRulesAsync
    // churchValidatePaymentAsync
} from '../../actions/DataActionExtension.g';
// @ts-ignore
import { Secondary } from '@churchofjesuschrist/eden-buttons';

const OverlayModal: React.FC<ICheckoutPaymentOverlayModal> = ({ modal }) => {
    return <Node {...modal} />;
};

const CheckoutPaymentInstrumentView: React.FC<ICheckoutPaymentInstrumentViewProps> = props => {
    const {
        checkoutPaymentInstrument,
        // className,
        // id,
        waiting,
        alert,
        paymentInformation,
        addPaymentForm,
        overlayModal,
        updateFunction,
        context,
        resources,
        updatePaymentAttributes
        // ...restProps
    } = props;
    // return (
    //     <Module {...checkoutPaymentInstrument} ref={checkoutErrorRef}>
    //         {waiting}
    //         {alert}
    //         {paymentInformation}
    //         {addPaymentForm}
    //         {overlayModal && <OverlayModal {...overlayModal} />}
    //     </Module>
    // );

    const [taxIdResults, setTaxIdResults] = React.useState<any>();
    const [isError, setIsError] = React.useState(false);
    const [idType, setIdType] = React.useState<any>();
    const [taxId, setTaxId] = React.useState<any>();
    const [isVisible, setIsVisible] = React.useState<any>(false);
    const [userCountry, setUserCountry] = React.useState<any>();
    const [hasRefreshed, setHasRefreshed] = React.useState<any>(false);

    const idTypeInputStyle: React.CSSProperties = {
        width: '100%',
        border: isError ? '1px solid red' : '1px solid rgb(135, 138, 140)',
        boxSizing: 'border-box',
        borderRadius: '2px',
        margin: '8px 0px',
        lineHeight: '22px',
        padding: '8px',
        fontSize: '16px',
        fontFamily: `"Ensign:Sans",Arial,"noto sans" ,sans-serif`,
        fontStyle: 'normal'
    };

    const idTypeStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        marginTop: '15px'
    };

    const handleSelect = async (option: any) => {
        const selectedOption = taxIdResults.filter((taxId: any) => {
            return taxId.TypeId === option;
        });
        if (selectedOption && selectedOption[0]) {
            sessionStorage.setItem('TaxId', selectedOption[0].TypeId);
        }

        setIdType(selectedOption[0].TypeId);
    };

    const onInputChange = (value: any) => {
        if (isError === true) {
            setIsError(false);
        }
        sessionStorage.setItem('idNum', value);
        setTaxId(value);
    };

    const getTaxIdInfo = async () => {
        const ctx = { callerContext: context.actionContext };
        let idTypes;
        // @ts-ignore
        if (props.data.cart && props.data.cart.result) {
            const getUserCountry: any =
                // @ts-ignore
                props.data.cart && props.data.cart.result && props.data.cart.result.cart && props.data.cart.result.cart.ExtensionProperties
                    ? // @ts-ignore
                      props.data.cart.result.cart.ExtensionProperties.filter((property: any) => {
                          return property.Key === 'Country';
                      })
                    : '';
            setUserCountry(getUserCountry);

            idTypes = await getIdentificationTypesAsync(ctx, getUserCountry[0].Value.StringValue).catch((err: any) => {
                return console.log(err);
            });
            if (idTypes && idTypes[0]) {
                sessionStorage.setItem('taxIdCheck', 'true');
            } else {
                sessionStorage.setItem('taxIdCheck', 'false');
                setIsVisible(true);
            }
        }

        return setTaxIdResults(idTypes);
    };
    const waitForUpdateFunction = async () => {
        await updateFunction();
    };
    React.useEffect(() => {
        const sessionTaxId = sessionStorage.getItem('TaxId');
        const sessionIdNum = sessionStorage.getItem('idNum');
        if (sessionTaxId) {
            setIdType(sessionTaxId);
        }
        if (sessionIdNum) {
            setTaxId(sessionIdNum);
        }
        // void waitForUpdateFunction();
        void getTaxIdInfo();
    }, []);

    React.useEffect(() => {
        const paymentType = sessionStorage.getItem('paymentTypeId');

        if (paymentType === '7' && hasRefreshed === false && props.isVisible === true) {
            setHasRefreshed(true);
            void waitForUpdateFunction();
        }
    }, [props]);

    const onClickCustom = async () => {
        const ctx = { callerContext: context.actionContext };

        const taxIdCheck = await getIdentificationTypesApplicabilityRulesAsync(ctx, userCountry[0].Value.StringValue, idType, taxId).catch(
            err => {
                console.log(err);
                setIsError(true);
            }
        );
        if (taxIdCheck) {
            await updatePaymentAttributes(idType, taxId).then(() => {
                setIsVisible(true);
            });
        }
    };

    return (
        <Module {...checkoutPaymentInstrument}>
            {taxIdResults && taxIdResults[0] ? (
                <div style={idTypeStyle}>
                    <label>{resources.taxIdLabel}</label>
                    <select style={idTypeInputStyle} onChange={(e: any) => handleSelect(e.target.value)} disabled={isVisible}>
                        <option value='' disabled selected>
                            {resources.taxIdPlaceholder}
                        </option>
                        {taxIdResults && taxIdResults[0]
                            ? taxIdResults.map((taxId: any) => {
                                  return (
                                      <option value={taxId.TypeId} key={taxId.Id} selected={idType === taxId.TypeId}>
                                          {taxId.Description}
                                      </option>
                                  );
                              })
                            : null}
                    </select>
                    <label>{resources.taxIdInputLabel}</label>
                    <input
                        type='text'
                        style={idTypeInputStyle}
                        onChange={(e: any) => onInputChange(e.target.value)}
                        value={taxId}
                        disabled={isVisible}
                    />
                    {isError && <small>{resources.taxIdErrorMessage}</small>}
                    {isVisible === false && <Secondary onClick={() => onClickCustom()}>{resources.applyPaymentLabel}</Secondary>}
                </div>
            ) : null}
            {isVisible && <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>{waiting}</div>}
            {alert}
            {paymentInformation}
            {isVisible && addPaymentForm}
            {overlayModal && <OverlayModal {...overlayModal} />}
        </Module>
    );
};

export default CheckoutPaymentInstrumentView;
